import React from 'react'
import { ReactComponent as Delete } from '../../assets/icons/delete.svg';
import { ReactComponent as Pen } from '../../assets/icons/pen.svg';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';

export const DeleteIcon = props => <Delete {...props} className={` ${props.className || ''}`} />
export const PenIcon = props => <Pen {...props} className={` ${props.className || ''}`} />
export const EditIcon = props => <Edit {...props} className={` ${props.className || ''}`} />